// If srp-tile-unlock-monthly is declared a winner move to icon folder and page
import { forwardRef } from 'react';
import type React from 'react';

type OwnProps = React.SVGProps<SVGSVGElement>;

const RefreshIcon = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="14"
    viewBox="0 0 12 14"
    fill="none"
    ref={ref}
    {...props}
  >
    <path
      d="M6.00026 3C3.24333 3 1 5.24292 1 8C1 10.7571 3.24333 13 6.00026 13C8.75667 13 11 10.7571 11 8"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 5V1L8 3L6 5Z"
      fill="white"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));

export default RefreshIcon;
